import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 12,
	viewBox: "0 0 13 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#403d47",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.552 2.2043L6.30195 0.0537634C6.07695 -0.0179211 5.92695 -0.0179211 5.70195 0.0537634L0.451953 2.2043C0.151953 2.27599 0.00195312 2.56272 0.00195312 2.84946V4.28315C0.00195312 4.71326 0.301953 5 0.751953 5H11.252C11.702 5 12.002 4.71326 12.002 4.28315V2.84946C12.002 2.56272 11.852 2.27599 11.552 2.2043Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .00195312,
			y: 10,
			width: 12,
			height: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3.00195,
			y: 6,
			width: 5,
			height: 2,
			transform: "rotate(90 3.00195 6)",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7.00195,
			y: 6,
			width: 5,
			height: 2,
			transform: "rotate(90 7.00195 6)",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.002,
			y: 6,
			width: 5,
			height: 2,
			transform: "rotate(90 11.002 6)",
			fill: "currentColor"
		})
	]
});
export default SvgAch;
